import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { localizeReducer } from "react-localize-redux";


import authentication from './authentication'
import error from './error'
import profile from "./profile"
import progress from './progress'
import role from './role'
import user from './user/user'
import userCreate from './user/userCreate'
import userDetail from './user/userDetail'
import userEdit from './user/userEdit'
import bank from './bank/bank'
import bankDetail from './bank/bankDetail'
import bankEdit from './bank/bankEdit'
import corporate from './corporate/corporate'
import corporateCreate from './corporate/corporateCreate'
import corporateDetail from './corporate/corporateDetail'
import corporateEdit from './corporate/corporateEdit'
import campaign from './campaign/campaign'
import campaignCreate from './campaign/campaignCreate'
import campaignDetail from './campaign/campaignDetail'
import campaignEdit from './campaign/campaignEdit'
import password from './password'
import file from './file/file'
import plick from './file/plick'
import plickDetail from './file/plickDetail'
import contoCorrente from './contoCorrente/contoCorrente'
import contoCorrenteCreate from './contoCorrente/contoCorrenteCreate'
import contoCorrenteEdit from './contoCorrente/contoCorrenteEdit'
import Index from "./Index"
import report from "./report"
import fileHistory from "./file/history"
import authNavbar from "./authNavbar"

const createRootReducers = (history) => combineReducers({
  router: connectRouter(history),
  localize: localizeReducer,
  authentication: authentication,
  dashboard:Index,
  error: error,
  password: password,
  progress: progress,
  role: role,
  user: user,
  userCreate: userCreate,
  userDetail: userDetail,
  userEdit: userEdit,
  bank: bank,
  bankDetail: bankDetail,
  bankEdit: bankEdit,
  corporate: corporate,
  corporateCreate: corporateCreate,
  corporateDetail: corporateDetail,
  corporateEdit: corporateEdit,
  campaign: campaign,
  campaignCreate: campaignCreate,
  campaignDetail: campaignDetail,
  campaignEdit: campaignEdit,
  file: file,
  fileHistory:fileHistory,
  plick: plick,
  plickDetail: plickDetail,
  profile: profile,
  contoCorrente: contoCorrente,
  contoCorrenteCreate: contoCorrenteCreate,
  contoCorrenteEdit: contoCorrenteEdit,
  report:report,
  authNavbar: authNavbar
})

export default createRootReducers